export enum FeatureFlags {
  ZendeskChat = "zendesk_chat",
  SSOclient = "client_sso_auth",
}
